/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { isEmpty, Spinner, Text, VFlow } from 'bold-ui'
import { AccordionCompositeItem } from 'components/accordion/AccordionCompositeItem'
import theme from 'config/theme'
import { ReceitaMedicamento } from 'graphql/types.generated'
import React from 'react'
import { Accordion } from 'react-accessible-accordion'
import { GrupoReceitaMedicamento } from 'view/atendimentos/detail/soap/plano/prescricao-medicamento/model-prescricao'

interface MedicamentosAccordionViewOnlyProps {
  loading: boolean
  grupos: GrupoReceitaMedicamento[]
  renderItemBody: (receita: ReceitaMedicamento) => JSX.Element
  renderItemHeader: (receita: ReceitaMedicamento, dataInicioGrupo: string) => JSX.Element
  renderGroupedBody: (grupo: ReceitaMedicamento[]) => JSX.Element
}

function MedicamentosAccordionViewOnly(props: MedicamentosAccordionViewOnlyProps) {
  const { loading, grupos, renderItemBody, renderItemHeader, renderGroupedBody } = props

  return (
    <div>
      <Accordion allowZeroExpanded={true} allowMultipleExpanded={true}>
        <VFlow vSpacing={0.5}>
          {loading && (
            <div css={styles.loadingContainer}>
              <Spinner />
              {'Carregando resultados'}
            </div>
          )}
          {!loading && isEmpty(grupos) && (
            <Text
              style={css`
                color: ${theme.pallete.text.secondary};
                font-style: italic;
                text-align: center;
              `}
            >
              Nenhum medicamento em uso
            </Text>
          )}
          {grupos.map(({ prescricoes }) => {
            const prescricaoPrincipal = prescricoes.first()
            const prescricaoMaisAntiga = prescricoes.last()
            return (
              <AccordionCompositeItem
                key={prescricaoPrincipal.receitaUsoContinuoGrupo?.id ?? prescricaoPrincipal.id}
                header={renderItemHeader(prescricaoPrincipal, prescricaoMaisAntiga.dtInicioTratamento)}
                body={prescricoes.length > 1 ? renderGroupedBody(prescricoes) : renderItemBody(prescricaoPrincipal)}
              />
            )
          })}
        </VFlow>
      </Accordion>
    </div>
  )
}

export default React.memo(MedicamentosAccordionViewOnly)

const styles = {
  loadingContainer: css`
    color: ${theme.pallete.primary.main};
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    & > *:first-of-type {
      margin-right: 0.5rem;
    }
  `,
}
